import { render, staticRenderFns } from "./MyCompanyTaxTypesNew.vue?vue&type=template&id=15457efd&"
import script from "./MyCompanyTaxTypesNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyTaxTypesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports